import * as actionTypes from './actionTypes'
import { quotationService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function getQuotations({ page = constants.GET_ALL_ITEMS, filter, reset, store } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_QUOTATIONS })

            dispatch({ type: actionTypes.FETCH_QUOTATIONS })

            const response = await quotationService.getQuotations(page, filter, store)
            const data = response.data

            dispatch({
                type: actionTypes.FETCH_QUOTATIONS_SUCCESS,
                payload: {
                    quotations: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize,
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_QUOTATIONS_FAILURE)
        }
    }
}

export function resetQuotations() {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.RESET_QUOTATIONS
        })
    }
}

export function getQuotation(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_QUOTATION })
            dispatch({ type: actionTypes.FETCH_QUOTATION })

            const response = await quotationService.getQuotation(id)
            const data = response.data

            dispatch({
                type: actionTypes.FETCH_QUOTATION_SUCCESS,
                payload: {
                    quotation: data,
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_QUOTATION_FAILURE)
        }
    }
}

export function resetQuotation() {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.RESET_QUOTATION
        })
    }
}

export function deleteQuotation(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.DELETE_QUOTATION })
            const response = await quotationService.deleteQuotation(id);

            dispatch({
                type: actionTypes.DELETE_QUOTATION_SUCCESS,
                payload: {
                    quotation: { id },
                }
            })
            dispatch({ type: actionTypes.RESET_QUOTATIONS });
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.DELETE_QUOTATION_FAILURE)
        }
    }
}

export function createQuotation(quotation) {
    return async (dispatch) => {
        try {

            dispatch({ type: actionTypes.CREATE_QUOTATION })

            const response = await quotationService.newQuotation(quotation)
            const data = response.data

            dispatch({
                type: actionTypes.CREATE_QUOTATION_SUCCESS,
                payload: {
                    quotation: data
                }
            })

            dispatch({ type: actionTypes.RESET_CREATE_QUOTATION })
        } catch (error) {
            errorHelper.handle(error.dispatch, actionTypes.CREATE_QUOTATION_FAILURE)
        }
    }
}

export function resetCreateQuotation() {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.RESET_CREATE_QUOTATION
        })
    }
}

export function updateQuotation(id, quotation) {
    return async (dispatch) => {
        try {

            dispatch({ type: actionTypes.UPDATE_QUOTATION })

            const response = await quotationService.updateQuotation(id, quotation)
            const data = response.data

            dispatch({
                type: actionTypes.UPDATE_QUOTATION_SUCCESS,
                payload: {
                    quotation: data
                }
            })

            dispatch({ type: actionTypes.RESET_UPDATE_QUOTATION })
        } catch (error) {
            errorHelper.handle(error.dispatch, actionTypes.UPDATE_QUOTATION_FAILURE)
        }
    }
}

export function resetUpdateQuotation() {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.RESET_UPDATE_QUOTATION
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/quotation/actions.js